/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ft_2_DescInputs */

const en_vc_ft_2_desc = /** @type {(inputs: Vc_Ft_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exact curve booleans, so no more "cannot perform operation". Plus Gradient Mesh, live radial Repeat and Envelope Distort.`)
};

const zh_vc_ft_2_desc = /** @type {(inputs: Vc_Ft_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精确的曲线布尔运算，再也不会出现「无法执行操作」。还有渐变网格、实时径向重复和封套扭曲。`)
};

/**
* | output |
* | --- |
* | "Exact curve booleans, so no more \"cannot perform operation\". Plus Gradient Mesh, live radial Repeat and Envelope Distort." |
*
* @param {Vc_Ft_2_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ft_2_desc = /** @type {((inputs?: Vc_Ft_2_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ft_2_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ft_2_desc(inputs)
	return zh_vc_ft_2_desc(inputs)
});
export { vc_ft_2_desc as "vc.ft.2.desc" }